export default function NoPermissionPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 text-center">
      <h1 className="mb-2 text-xl font-semibold text-slate-800">No permission</h1>
      <p className="max-w-md text-sm text-slate-600">
        We could not load your employee profile from SSO. You may not have access to this application.
      </p>
    </div>
  );
}
